import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UserConfigService } from "./user-config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../shared/services/auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-user-config',
  templateUrl: './user-config.component.html',
  styleUrls: ['./user-config.component.scss']
})
export class UserConfigComponent {
  public isInsert: boolean;
  public isSubmitted: boolean;
  public isLoaded: boolean;
  public users: any[] = [];
  public selectedUser: any = null;
  public validationCode: string = '';
  public validatingTotp: boolean = false;
  public errorMessage: string = '';
  public pendingAction: 'create' | 'toggle' | 'reset' | null = null;
  public pendingUser: any = null;
  public resettingId: string | null = null;
  public pendingResetUser: any = null;
  public readonly allowedByRole = this.authService.isCommon();
  @ViewChild('requestTOTPCode') validateToken: ElementRef | any;


  user = new FormGroup({
    email: new FormControl<string>('', [Validators.required, Validators.email]),
    name: new FormControl<string>('', Validators.required),
    rolesAccount: new FormControl<number>(3, Validators.required),
    terms: new FormControl<boolean>(false)
  });

  constructor(private userConfigService: UserConfigService,
    private modalService: NgbModal,
    private authService: AuthService,
    private toastr: ToastrService) {
    this.isInsert = false;
    this.isSubmitted = false;
    this.isLoaded = false;
    this.loadUsers();
  }

  loadUsers() {
    this.isLoaded = false;
    this.userConfigService.getUsers().subscribe(response => {
      this.users = Array.isArray(response.users) ? response.users : [];
      this.isLoaded = true;
    });
  }

  async pasteTotpCode() {
    try {
      const text = await navigator.clipboard.readText();
      this.validationCode = text.trim();
    } catch (err) {
      this.toastr.error('Erro ao colar o código do clipboard');
    }
  }

  doCreateUser() {
    const { email, name } = this.user.value;
    const rolesAccount = Number(this.user.value.rolesAccount);

    const userData = {
      email,
      name,
      rolesAccount,
      admCreate: false
    };

    this.userConfigService.addUser(userData).subscribe({
      next: () => {
        this.toastr.success('Usuário criado com sucesso!', 'Sucesso');
        this.user.reset({ rolesAccount: 3, terms: false });
        this.return();
        this.isLoaded = true;
      },
      error: (error) => {
        const mensagem = error?.error?.mensagem || 'Erro ao criar usuário.';
        this.toastr.error(mensagem, 'Erro');
        this.isLoaded = true;
      }
    });
  }

  onResetClick(user: any) {
    if (!this.authService.isCommon()) {
      this.toastr.error('Ação não permitida.');
      return;
    }

    this.pendingResetUser = user;
    this.pendingAction = 'reset';
    this.validationCode = '';
    this.errorMessage = '';

    this.modalService.open(this.validateToken, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'sm'
    });
  }



  async validateTotp() {
    if (this.validatingTotp) return;
    this.validatingTotp = true;

    this.isLoaded = false;
    const isValid = await this.authService.validateTotpCode(this.validationCode).then(r => r.isValid);

    if (isValid) {
      this.modalService.dismissAll();
      this.validationCode = '';
      this.errorMessage = '';

      if (this.pendingAction === 'create') {
        this.doCreateUser();
      } else if (this.pendingAction === 'toggle') {
        this.doToggleUserActive(this.pendingUser);
      } else if (this.pendingAction === 'reset' && this.pendingResetUser) {
        await this.doResetPassword(this.pendingResetUser);
      }

      this.pendingAction = null;
      this.pendingUser = null;
      this.pendingResetUser = null;
    } else {
      this.errorMessage = 'Código de autenticação inválido!';
      this.isLoaded = false;
    }
    this.validatingTotp = false;
  }

  private openTotpModal() {
    this.modalService.open(this.validateToken, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'sm',
    });
  }

  onToggleClick(ev: MouseEvent, modalTpl: any, user: any) {
    ev.preventDefault();
    ev.stopPropagation();

    if (!this.allowedByRole) {
      this.toastr.error('Seu perfil não pode ativar/desativar usuários.', 'Acesso negado');
      return;
    }

    this.selectedUser = user;
    this.modalService.open(modalTpl, { size: 'sm' });
  }

  toggleActive(user: any) {
    if (!this.allowedByRole) {
      this.toastr.error('Seu perfil não pode ativar/desativar usuários.', 'Acesso negado');
      return;
    }
    this.modalService.dismissAll();
    this.pendingAction = 'toggle';
    this.pendingUser = user;
    this.openTotpModal();
  }

  doToggleUserActive(user: any) {
    this.userConfigService.toggleUserActive(user.email, !user.active).subscribe({
      next: () => {
        this.toastr.success('Status do usuário atualizado com sucesso!', 'Sucesso');
        this.loadUsers();
        this.isLoaded = true;
      },
      error: (err) => {
        this.toastr.error('Erro ao atualizar o status do usuário.', 'Erro');
        console.error(err);
        this.loadUsers();
        this.isLoaded = true;
      }
    });
  }

  private async doResetPassword(user: any) {
  this.resettingId = user.id;

  this.userConfigService.resetPassword(user.email).subscribe({
    next: () => {
      this.toastr.success(`Senha de ${user.name} resetada com sucesso!`, 'Sucesso');
      this.loadUsers();
    },
    error: (err) => {
      const msg = err?.error?.mensagem || 'Falha ao resetar a senha do usuário.';
      this.toastr.error(msg, 'Erro');
      console.error(err);
    },
    complete: () => {
      this.resettingId = null;
    }
  });
}

  showConfirmEnableDisable(modal: any, user: any) {
    if (!this.allowedByRole) {
      this.toastr.error('Seu perfil não pode ativar/desativar usuários.', 'Acesso negado');
      return;
    }
    this.selectedUser = user;
    this.modalService.open(modal, { size: 'sm' });
  }

  openInsert() {
    if (!this.allowedByRole) {
      this.toastr.error('Seu perfil não pode criar usuários.', 'Acesso negado');
      return;
    }
    this.isInsert = true;
  }

  return() {
    this.isInsert = false;
    this.loadUsers();
    this.clearForm();
  }

  clearForm() {
    this.isSubmitted = false;
  }

  add() {
    if (!this.allowedByRole) {
      this.toastr.error('Seu perfil não pode criar usuários.', 'Acesso negado');
      return;
    }
    this.isSubmitted = true;
    if (!this.user.controls.terms.value) {
      this.toastr.error("Aceite os termos!", 'Erro');
      return;
    }
    if (this.user.valid) {
      this.pendingAction = 'create';
      this.openTotpModal();
    }
  }
}
